const Dates = [
    { value: 'Todos', label: 'Todos' },
    { value: 'Más recientes', label: 'Más recientes' },
    { value: 'Más antiguos', label: 'Más antiguos' },
    { value: 'Esta semana', label: 'Esta semana' },
    { value: 'Este mes', label: 'Este mes' },
    { value: 'Este año', label: 'Este año' },
    { value: 'Fecha específica', label: 'Fecha específica' },
];

const Categories = [
    { value: "Todos",           label: "Todos"},
    { value: "Talento mujer",   label: "Talento mujer"},
    { value: "Talento joven",   label: "Talento joven"},
    { value: "Inclusión",       label: "Inclusión"},
    { value: "Tendencias",      label: "Tendencias"},
    { value: "Talento 4.0",     label: "Talento 4.0"}
];

const ThemeColors = {
    "default" :         {bgColor: "#FFF7F3",  bgColorBanner: "var(--color-orange-dark)",            color: "#ee2b7b"},
    "Talento mujer" :   {bgColor: "#fce3ed",  bgColorBanner: "var(--color-tema-talentomujer-bg)",   color: "#ee2b7b"},
    "Talento 4.0" :     {bgColor: "#edf0fb",  bgColorBanner: "var(--color-tema-talento4-bg)",       color: "#6b5683"},
    "Tendencias" :      {bgColor: "#f8ebe9",  bgColorBanner: "var(--color-tema-tendencias-bg)",     color: "#8b5045"},
    "Talento joven" :   {bgColor: "#e0f2f2",  bgColorBanner: "var(--color-tema-talentojoven-bg)",   color: "#006b62"},
    "Inclusión" :       {bgColor: "#eeeeee",  bgColorBanner: "var(--color-tema-inclusion-bg)",      color: "#474747"}
};

const SortingOpts = [{value: "1", label : "Más reciente"}, {value: "2", label : "Más antiguo"}];

export { Dates, Categories, ThemeColors, SortingOpts }
